import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { BaseComponent } from '@uw/core/base.component';
import { AuthService } from '@uw/core/services/auth.service';
import { CampaignStateService } from '@uw/core/services/campaign-state.service';
import { CampaignService } from '@uw/core/services/campaign.service';
import { MenuService } from '@uw/themes/services/menu.service';
import { MyErrorStateMatcher } from '../login-page/login-page.component';
import { CustomNavigationService } from '@uw/core/custom-navigation.service';
import { customEmailValidator } from '@uw/shared/validators/custom-email-validator';
import { MatInput, MatError } from '@angular/material/input';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { MatButton } from '@angular/material/button';
import { UwRouterLink } from '../../../../shared/directives/directives/uw-router-link.directive';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    imports: [ReactiveFormsModule, MatInput, MatError, ButtonComponent, MatButton, UwRouterLink, TranslateModule]
})
export class ForgotPasswordComponent extends BaseComponent implements OnInit {
  forgotFormGrp!: UntypedFormGroup;
  matcher = new MyErrorStateMatcher();
  buttonLoading = false;
  errorMessage = '';
  campaignGuid: string;
  constructor(private fb: UntypedFormBuilder,
    private authService: AuthService,
    private menuService: MenuService,
    private customNavigationService: CustomNavigationService,
    private campaignService: CampaignService,
    private campaignStateService: CampaignStateService,
    ) {
    super();
    //this.menuService.showDonarSubMenu(true);
    this.createForm();
  }

  ngOnInit(): void {
    this.campaignGuid = this.campaignStateService.getSelectedCampaign()?.campaignGuid ?? '';
  }

  createForm(){
    this.forgotFormGrp = this.fb.group({
      email: [null,[Validators.required, customEmailValidator()]],
    });
  }

  onNoClick(): void {
    //this.dialogRef.close();
  }

  forgotPassword(): void {
    this.buttonLoading = true;
    const cGuid = this.campaignService.getCurrentCampaignGuid();
    this.authService.forgotPassword(this.forgotFormGrp.value.email, cGuid ?? '').subscribe(_data=> {

        this.buttonLoading = false;
        this.showSuccess('forgot_password.success_msg', {email: this.forgotFormGrp.value.email});
        this.customNavigationService.navigate(['/donor', this.campaignGuid]);

    }, err=>{
      this.buttonLoading = false;
      this.errorMessage = err && err.message  ? err.message : this.translateService.instant('messages.forgot_password_error')
    });

  }

}
